import { render, staticRenderFns } from "./NewVerticalNavMenu.vue?vue&type=template&id=65dc46cb&"
import script from "./NewVerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./NewVerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewVerticalNavMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports